import {v4} from 'uuid';

const readSessionId = () => {
    const idInStorage = window.sessionStorage.getItem('sessionId');

    if (idInStorage === null) {
        const generatedId = v4();

        window.sessionStorage.setItem('sessionId', generatedId);

        return generatedId;
    }

    return idInStorage;
};

const initRiskified = () => {
    const storeDomain = window.location.hostname;
    const sessionId = readSessionId();
    const protocol =
    document.location.protocol === 'https:' ? 'https://' : 'http://';
    const url = `${protocol}beacon.riskified.com?shop=${storeDomain}&sid=${sessionId}`;
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = url;
    document.head.appendChild(s);

    return true;
};

export default initRiskified;
